import { render, staticRenderFns } from "./GReCaptcha.vue?vue&type=template&id=ffaa2502&scoped=true&"
import script from "./GReCaptcha.vue?vue&type=script&lang=ts&"
export * from "./GReCaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa2502",
  null
  
)

export default component.exports